module.exports = __webpack_public_path__ + "media/es_slide3_video.22debfc6.mp4";